import { Box, Button, FormLabel, Heading, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import MainModel from "../../../components/Models/main-model";
import { closeChangeGroupModal } from "../../../modules/admin-modules/models/Actions";
import {
  approveStudentEnrollCourseRequest,
  getAllEnrollCourseRequest,
} from "../../../modules/superadmin-modules/courses/Actions";
import { getCourseGroupRequest } from "../../../modules/superadmin-modules/groups/Actions";

const ChangeGroupModal = ({ selectedData, courseId }) => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.model.isOpen36); // New modal state
  const isLoading = useSelector((state) => state.courses.isLoading);
  const { groups } = useSelector((state) => state.superadminGroups);

  const [selectedGroup, setSelectedGroup] = useState(null);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  useEffect(() => {
    if (isOpen && courseId) {
      dispatch(getCourseGroupRequest(courseId));
    }
  }, [isOpen, courseId]);

  useEffect(() => {
    if (selectedData?.student_group) {
      setSelectedGroup({
        label: selectedData.student_group.name,
        value: selectedData.student_group.id,
      });
    }
  }, [selectedData]);

  const groupsOptions = groups?.map((group) => ({
    value: group.id,
    label: group.name,
  }));

  const handleApprove = () => {
    if (!selectedGroup) {
      toast.error("Please select a group");
      return;
    }

    dispatch(
      approveStudentEnrollCourseRequest({
        data: {
          student_id: selectedData?.user?.id,
          course_id: courseId,
          student_group_id: selectedGroup.value,
        },
        action: () => {
          dispatch(getAllEnrollCourseRequest(courseId));
          dispatch(closeChangeGroupModal());
          toast.success("Student enrollment approved successfully");
        },
      })
    );
  };

  const closeFunc = () => {
    dispatch(closeChangeGroupModal());
    setSelectedGroup(null);
  };

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        تغيير مجموعة الطالب
      </Heading>
      {selectedData?.user?.name && (
        <Text textAlign="center" color="gray.600" fontSize="16px" mt={2}>
          {selectedData.user.name}
        </Text>
      )}
    </Box>
  );

  return (
    <MainModel
      header={header}
      closeFunc={closeFunc}
      openVar={isOpen}
      buttonTitle="موافقة"
      buttonFunc={handleApprove}
      size="md"
      isLoading={isLoading}
      closeButtonTitle="إلغاء"
    >
      <Box w="100%" dir="rtl">
        <FormLabel>المجموعة الحالية: {selectedData?.student_group?.name}</FormLabel>
        <FormLabel>اختر مجموعة جديدة:</FormLabel>
        <Select
          options={groupsOptions}
          onChange={(data) => setSelectedGroup(data)}
          styles={colourStyles}
          placeholder="اختر مجموعة"
          value={selectedGroup}
        />
      </Box>
    </MainModel>
  );
};

export default ChangeGroupModal; 